import { Navigate, useLocation, useParams, Link } from "react-router-dom";
import { useAuthStatus } from "../authHooks";
import { URLs, pathForPendingFlow } from "../AuthRoutingWrappers";

export default function ProviderCallback() {
  const { mode } = useParams();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const error = params.get("error");
  const [auth, status] = useAuthStatus();

  let url: string = URLs.LOGIN_URL;
  if (status.isAuthenticated) {
    url = URLs.LOGIN_REDIRECT_URL;
  } else {
    url = pathForPendingFlow(auth) || url;
  }
  if (!error) {

    if (mode === "web-extension-popup") {
      window.close();
    } else {
      return <Navigate to={url} />;
    }
  }
  // TODO: This fails when the user already exists (because it was created with email/pwd previously)
  return (
    <>
      <h1>Third-Party Login Failure</h1>
      <p>Something went wrong. If you have a Sharpana account with email/pwd you'll need to use that (instead of Google/Social Login).</p>
      <p>If that's not your case please contact support!</p>
      <Link to={url}>Continue</Link>
    </>
  );
}
